import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import AdminRoute from '../components/AdminRoute';

// User Pages
import UserDashboard from '../pages/UserDashboard';
import UserProfilePage from '../pages/UserProfilePage';
import UserBookingsPage from '../pages/UserBookingsPage';
import UserContactPage from '../pages/UserContactPage';
import UserSupportTickets from '../pages/UserSupportTickets';
import MessagesPage from '../pages/MessagesPage';
import MeetingPage from '../pages/MeetingPage';

// Shop / Payment Pages
import OrdersPage from '../pages/shop/OrdersPage';
import PaymentPage from '../pages/PaymentPage';
import StripeSuccessPage from '../pages/StripeSuccessPage';
import StripeCancelPage from '../pages/StripeCancelPage';

// Trainer Pages
import TrainerDashboard from '../pages/TrainerDashboard';
import TrainerAccountSettings from '../components/trainer/TrainerAccountSettings';

// Admin Pages
import AdminDashboard from '../pages/admin/AdminDashboardNew';
import AdminBlogPage from '../pages/admin/AdminBlogPage';
import CustomerDetailView from '../components/admin/CustomerDetailView';
import AdminAccountSettings from '../components/admin/AdminAccountSettings';
import DashboardLayout from '../components/DashboardLayout';

export const userRoutes = (
  <>
    <Route path="/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
    <Route path="/messages" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
    <Route path="/user/dashboard" element={<ProtectedRoute allowedRoles={['user']}><UserDashboard /></ProtectedRoute>} />
    <Route path="/user/profile" element={<ProtectedRoute allowedRoles={['user']}><UserProfilePage /></ProtectedRoute>} />
    <Route path="/user/messages" element={<ProtectedRoute allowedRoles={['user']}><MessagesPage /></ProtectedRoute>} />
    <Route path="/user/bookings" element={<ProtectedRoute allowedRoles={['user']}><UserBookingsPage /></ProtectedRoute>} />
    <Route path="/user/contact" element={<ProtectedRoute allowedRoles={['user']}><UserContactPage /></ProtectedRoute>} />
    <Route path="/user/support-tickets" element={<ProtectedRoute allowedRoles={['user']}><UserSupportTickets /></ProtectedRoute>} />
    <Route path="/meeting/:bookingId" element={<ProtectedRoute allowedRoles={['user', 'trainer']}><MeetingPage /></ProtectedRoute>} />
    <Route path="/payment/stripe-success" element={<ProtectedRoute allowedRoles={['trainer', 'user']}><StripeSuccessPage /></ProtectedRoute>} />
    <Route path="/payment/stripe-cancel" element={<ProtectedRoute allowedRoles={['trainer', 'user']}><StripeCancelPage /></ProtectedRoute>} />
  </>
);

export const trainerRoutes = (
  <>
    <Route path="/trainer/dashboard" element={<ProtectedRoute allowedRoles={['trainer']}><TrainerDashboard /></ProtectedRoute>} />
    <Route path="/trainer/messages" element={<ProtectedRoute allowedRoles={['trainer']}><MessagesPage /></ProtectedRoute>} />
    <Route path="/trainer/account" element={<ProtectedRoute allowedRoles={['trainer']}><TrainerAccountSettings /></ProtectedRoute>} />
    <Route path="/trainer/support-tickets" element={<ProtectedRoute allowedRoles={['trainer']}><UserSupportTickets /></ProtectedRoute>} />
    <Route path="/payment" element={<ProtectedRoute allowedRoles={['trainer']}><PaymentPage /></ProtectedRoute>} />
  </>
);

export const adminRoutes = (
  <>
    <Route path="/admin" element={<ProtectedRoute allowedRoles={['admin']}><AdminDashboard /></ProtectedRoute>} />
    <Route path="/admin/trainers" element={<ProtectedRoute allowedRoles={['admin']}><AdminDashboard defaultTab="trainers" /></ProtectedRoute>} />
    <Route path="/admin/users" element={<ProtectedRoute allowedRoles={['admin']}><AdminDashboard defaultTab="customers" /></ProtectedRoute>} />
    <Route path="/admin/customer/:customerId" element={<ProtectedRoute allowedRoles={['admin']}><CustomerDetailView /></ProtectedRoute>} />
    <Route path="/admin/account" element={<ProtectedRoute allowedRoles={['admin']}><DashboardLayout><AdminAccountSettings /></DashboardLayout></ProtectedRoute>} />
    <Route path="/admin/blog" element={<AdminRoute><AdminBlogPage /></AdminRoute>} />
  </>
);
